import type { ResourcesValue } from '../resources';
import { saveSpreadsheet } from '../../utils/spreadsheet/save';

export type BadgeAward = {
  id: number;
  awardedToUserInternalId?: string;
  awardedTo: string;
  awardedToUserId: number;
  awardedToUnit: string;
  badge: string;
  badgeId: number;
  awardedByUserInternalId?: string;
  awardedBy: string;
  awardedByUserId: number;
  awardedByUnit: string;
  awardedOn: string;
};

export const createListExporter = (resource: ResourcesValue) => {
  return async (badgesAwards: BadgeAward[]) => {
    const mapped = badgesAwards.map((bA: BadgeAward) => {
      return {
        AwardedToInternalID: bA.awardedToUserInternalId,
        AwardedTo: bA.awardedTo,
        AwardedToUnit: bA.awardedToUnit,
        Badge: bA.badge,
        AwardedByInternalID: bA.awardedByUserInternalId,
        AwardedBy: bA.awardedBy,
        AwardedByUnit: bA.awardedByUnit,
        AwardedOn: bA.awardedOn,
      };
    });

    await saveSpreadsheet({
      format: 'csv',
      data: mapped,
      basename: resource,
    });
  };
};
